var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06258 13.2917H5.55841C4.88168 13.2917 4.54332 13.2917 4.28484 13.4234C4.05748 13.5392 3.87263 13.7241 3.75678 13.9514C3.62508 14.2099 3.62508 14.5483 3.62508 15.225V25.375M19.9376 13.2917H23.4417C24.1185 13.2917 24.4568 13.2917 24.7153 13.4234C24.9427 13.5392 25.1275 13.7241 25.2434 13.9514C25.3751 14.2099 25.3751 14.5483 25.3751 15.225V25.375M19.9376 25.375V7.49167C19.9376 6.13821 19.9376 5.46148 19.6742 4.94452C19.4425 4.4898 19.0728 4.12009 18.6181 3.8884C18.1011 3.625 17.4244 3.625 16.0709 3.625H12.9292C11.5758 3.625 10.8991 3.625 10.3821 3.8884C9.92738 4.12009 9.55768 4.4898 9.32598 4.94452C9.06258 5.46148 9.06258 6.13821 9.06258 7.49167V25.375M26.5834 25.375H2.41675M13.2917 8.45833H15.7084M13.2917 13.2917H15.7084M13.2917 18.125H15.7084",
    stroke: "#E83E8C",
    strokeWidth: 2.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding07);
export default __webpack_public_path__ + "static/media/building-07.059ff5b5127cf329c67b77d4e7575d91.svg";
export { ForwardRef as ReactComponent };